// material-ui
import { createTheme } from '@mui/material/styles';

// assets
import defaultColor from '../assets/scss/_themes-vars.module.scss';

// ==============================|| DEFAULT THEME - PALETTE ||============================== //

export default function Palette(mode, presetColor) {
  let colors;
  switch (presetColor) {
    case 'default':
    default:
      colors = defaultColor;
  }

  const isDark = mode === 'dark';

  return createTheme({
    palette: {
      mode,
      common: {
        black: isDark ? '#000000' : colors.darkPaper
      },
      primary: {
        light: isDark ? '#90caf9' : colors.primaryLight,
        main: isDark ? '#64b5f6' : colors.primaryMain,
        dark: isDark ? '#42a5f5' : colors.primaryDark,
        200: isDark ? '#90caf9' : colors.primary200,
        800: isDark ? '#1565c0' : colors.primary800
      },
      secondary: {
        light: isDark ? '#7091e6' : colors.secondaryLight,
        main: isDark ? '#5575d1' : colors.secondaryMain,
        dark: isDark ? '#3d52a0' : colors.secondaryDark,
        200: isDark ? '#7091e6' : colors.secondary200,
        800: isDark ? '#2c3e7d' : colors.secondary800
      },
      error: {
        light: isDark ? '#ef5350' : colors.errorLight,
        main: isDark ? '#f44336' : colors.errorMain,
        dark: isDark ? '#c62828' : colors.errorDark
      },
      orange: {
        light: isDark ? '#ffb74d' : colors.orangeLight,
        main: isDark ? '#ff9800' : colors.orangeMain,
        dark: isDark ? '#f57c00' : colors.orangeDark
      },
      warning: {
        light: isDark ? '#ffb74d' : colors.warningLight,
        main: isDark ? '#ffa726' : colors.warningMain,
        dark: isDark ? '#f57c00' : colors.warningDark,
        contrastText: isDark ? '#000000' : colors.grey700
      },
      success: {
        light: isDark ? '#66bb6a' : colors.successLight,
        200: isDark ? '#81c784' : colors.success200,
        main: isDark ? '#4caf50' : colors.successMain,
        dark: isDark ? '#388e3c' : colors.successDark
      },
      grey: {
        50: isDark ? '#fafafa' : colors.grey50,
        100: isDark ? '#f5f5f5' : colors.grey100,
        500: isDark ? '#9e9e9e' : colors.grey500,
        600: isDark ? '#757575' : colors.grey600,
        700: isDark ? '#616161' : colors.grey700,
        900: isDark ? '#212121' : colors.grey900
      },
      dark: {
        light: isDark ? '#e0e0e0' : colors.darkTextPrimary,
        main: isDark ? '#2a2a2a' : colors.darkLevel1,
        dark: isDark ? '#1a1a1a' : colors.darkLevel2,
        800: isDark ? '#121212' : colors.darkBackground,
        900: isDark ? '#0a0a0a' : colors.darkPaper
      },
      text: {
        primary: isDark ? '#ffffff' : colors.grey700,
        secondary: isDark ? '#b0b0b0' : colors.grey500,
        dark: isDark ? '#ffffff' : colors.grey900,
        hint: isDark ? '#666666' : colors.grey100
      },
      divider: isDark ? '#333333' : colors.grey200,
      background: {
        paper: isDark ? '#1a1a1a' : colors.paper,
        default: isDark ? '#0a0a0a' : colors.paper
      }
    }
  });
}

// Define your Berry Dashboard color palette
export const theme = {
  primary: {
    light: '#f0f5ff',
    main: '#2196f3',
    dark: '#1e88e5',
    200: '#90caf9',
    800: '#1565c0'
  },
  secondary: {
    light: '#f0f5ff',
    main: '#3d52a0',
    dark: '#3d52a0',
    200: '#7091e6',
    800: '#3d52a0'
  }
};